// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://dboofwbcktirmwlfiiml.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRib29md2Jja3Rpcm13bGZpaW1sIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA0ODk3MDAsImV4cCI6MjA1NjA2NTcwMH0.YtU-IOJv8XnkDND5AeMYlukU8Q7bqE0djgBjnaCMT8A";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);